const EMAIL_WARNINGS = ['@yaho.', '@gnail', '@hotnail', '.con'] as (
  | '@yaho.'
  | '@gnail'
  | '@hotnail'
  | '.con'
)[]
const EMAIL_WARNING_KEYS = {
  '@yaho.': 'email_yaho_warning',
  '@gnail': 'email_gnail_warning',
  '@hotnail': 'email_hotnail_warning',
  '.con': 'email_.con_warning',
}

export const hasWarning = (email: string) =>
  EMAIL_WARNINGS.some((warning) => email?.includes(warning))

export const getWarnings = (email: string) =>
  EMAIL_WARNINGS.filter((warning) => email?.includes(warning))

export const getWarningKeys = (email: string) =>
  getWarnings(email).map((warning) => EMAIL_WARNING_KEYS[warning])
